/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choose_New_TitleInputs */

const en_plan_choose_new_title = /** @type {(inputs: Plan_Choose_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From an idea`)
};

const id_plan_choose_new_title = /** @type {(inputs: Plan_Choose_New_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari ide`)
};

/**
* | output |
* | --- |
* | "From an idea" |
*
* @param {Plan_Choose_New_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const plan_choose_new_title = /** @type {((inputs?: Plan_Choose_New_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choose_New_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_plan_choose_new_title(inputs)
	return en_plan_choose_new_title(inputs)
});